import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'

/**
 * AD-192: the targeting an integration saves for its regions — the same shape as the
 * tier mutations next door.
 */

// Laravel's own message for a failed validation is "The given data was invalid",
// which tells the admin nothing. The field errors carry the reason.
const notifyError = ({ response }) => notifications.show({
    color: 'red',
    title: 'Error',
    message: Object.values(response?.data?.errors || {})[0]?.[0]
        || response?.data?.message
        || '',
});

const notifySuccess = (message) => notifications.show({
    color: 'green',
    title: 'Success',
    message,
});

export const mutateRegionTargetingStore = ({ integrationId }) => useMutation({
    mutationKey: ['integration-region-store', integrationId],
    mutationFn: async (formData) => axios.post(
        route('studio.v1.api.integrations.region-targeting.store', integrationId),
        formData,
    ),
    onSuccess: async () => notifySuccess('Targeting added'),
    onError: notifyError,
});

export const mutateRegionTargetingUpdate = ({ integrationId, regionTargetingId }) => useMutation({
    mutationKey: ['integration-region-update', integrationId, regionTargetingId],
    mutationFn: async (formData) => axios.put(
        route('studio.v1.api.integrations.region-targeting.update', [integrationId, regionTargetingId]),
        formData,
    ),
    onSuccess: async () => notifySuccess('Targeting saved'),
    onError: notifyError,
});

export const mutateRegionTargetingDelete = ({ integrationId, regionTargetingId }) => useMutation({
    mutationKey: ['integration-region-delete', integrationId, regionTargetingId],
    mutationFn: async () => axios.delete(
        route('studio.v1.api.integrations.region-targeting.destroy', [integrationId, regionTargetingId]),
    ),
    onSuccess: async () => notifySuccess('Targeting deleted'),
    onError: notifyError,
});
